export class UnauthorizedError extends Error {}

export class TokenError extends Error {}

export class UserDeclineError extends Error {}
